var map = {
	"./historicaldata.json": 22865,
	"./status-2010-2011.json": 82860,
	"./status-2011-2012.json": 236,
	"./status-2012-2013.json": 53163,
	"./status-2013-2014.json": 28568,
	"./status-2014-2015.json": 92740,
	"./status-2015-2016.json": 36452,
	"./status-2016-2017.json": 1672,
	"./status-2017-2018.json": 81800,
	"./status-2018-2019.json": 7436,
	"./status-2019-2020.json": 87837,
	"./status-2020-2021.json": 52238,
	"./status-2021-2022.json": 154,
	"./status-2022-2023.json": 10322,
	"./status-2023-2024.json": 7118,
	"./status-2024-2025.json": 24830,
	"./status-2025-2026.json": 96706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71444;